export default "__VITE_ASSET__BecPNnSR__"